import createStore from "astrid-helpers/src/createStore";

export const [getLasso, setLasso, useLasso, onLasso] = createStore();
